module.exports = __webpack_public_path__ + "img/maky-2.dd32adc5.png";